export default "__VITE_ASSET__f5a9971b__"